import * as ACTION_TYPES from "@stores/actions/action_types";
export const initialState = {
  theme: {
    layout: {},
    settings: {},
  },
  current_theme: {},
  error: [],
  new_theme: {
    layout: {},
  },
  edit_theme: {
    isDirty: false,
    /** `null` = main navigate menu; set via `open_option` khi drill-down vào settings. */
    option: null as null | {
      action: string;
      element: string;
      id: string;
      name: string;
      [key: string]: unknown;
    },
  },
  output: "",
  is_update: false,
  is_update_preview: false,
  change_theme: false,
  update_theme: false,
  is_open_change_theme: false,
  tab_change_theme: 0,
  edit_name_theme: null,
};
const ThemesReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case ACTION_TYPES.GET_LAYOUTS:
      return {
        ...state,
        layout: action.layout,
        layout_types: action.layout_types,
      };
    case ACTION_TYPES.CHANGE_THEME:
      return {
        ...state,
        theme: { ...state.theme, ...action.theme },
        change_theme: true,
        // edit_theme: { ...state.edit_theme, isDirty: true }
      };
    case ACTION_TYPES.CHANGE_THEME_SUCCESSFUL:
      return {
        ...state,
        change_theme: false,
      };
    case ACTION_TYPES.UPDATE_THEME_COMPLETED:
      return {
        ...state,
        edit_theme: { ...state.edit_theme, isDirty: false },
      };
    case ACTION_TYPES.UPDATE_PREVIEW_THEME:
      return {
        ...state,
        is_update_preview: action.is_update_preview,
      };
    case ACTION_TYPES.CHOOSE_LAYOUT:
      return {
        ...state,
        new_theme: { ...state.new_theme, ...action.new_theme },
      };
    case ACTION_TYPES.CREATE_THEME_SUCCESSFUL:
      return {
        ...state,
        new_theme: { layout: {} },
      };
    case ACTION_TYPES.SHOW_THEME:
      return {
        ...state,
        current_theme: action.theme,
        theme: action.theme,
        // default_settings: action.theme.settings,
      };
    case ACTION_TYPES.OPEN_OPTION:
      return {
        ...state,
        edit_theme: {
          ...state.edit_theme,
          option: action.option,
        },
      };
    case ACTION_TYPES.OPEN_NAVIGATE:
      return {
        ...state,
        edit_theme: {
          ...state.edit_theme,
          option: null,
        },
      };
    case ACTION_TYPES.PREVIEW_THEME:
      return {
        ...state,
        output: action.output,
      };
    case ACTION_TYPES.UPDATE_THEME:
      return {
        ...state,
        update_theme: true,
      };
    case ACTION_TYPES.UPDATE_THEME_SUCCESSFUL:
      return {
        ...state,
        update_theme: false,
      };
    case ACTION_TYPES.RESET_CHANGE_THEME:
      return {
        ...state,
        change_theme: false,
      };
    case "OPEN_CHANGE_THEME":
      return {
        ...state,
        is_open_change_theme: action.isOpen,
        tab_change_theme: action.tabChange ?? 0,
        edit_name_theme: action.themeId ?? null,
      };
    case "OPEN_ACTIVE_CHANGE_THEME":
      return {
        ...state,
        is_open_change_theme: action.isOpen,
      };
    case "TAB_CHANGE_THEME":
      return {
        ...state,
        tab_change_theme: action.tabChange,
        edit_name_theme: null
      };
    case "RESET_CHANGE_THEME":
      return {
        ...state,
        is_open_change_theme: false,
        tab_change_theme: 0,
        edit_name_theme: null,
      };
    default:
      return state;
  }
};
export default ThemesReducer;